import emptyState from "./emptyState";
import { IAction } from "../../models/Action";
import { actionTypes } from "./actions";
import { GlobalConfig, STATE_IDENTIFIER } from "./constants";
import { compose } from "redux";
import { immutableSet } from "../../utils/immutable";

const {
  REQUESTS_HISTORY_FETCH_LIMIT,
  RETRYABLE_REQUEST_TYPES,
  SMS_ENABLED,
  SMS_MOBILE_NUMBER_EDITABLE_BY_USER,
  MODIFY_PROFILE_CA_OTP_ENABLED,
  MODIFY_PROFILE_SEC_QUESTIONS_ENABLED,
  MODIFY_PROFILE_UIGP_OTP_ENABLED,
  DELEGATE_CONSULTANT_ENABLED,
} = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.LOAD_CONFIGURATIONS_SUCCESS]: (state: any, action: any) => {
    const configurations: GlobalConfig[] = action.payload.globalConfigurations;
    let smsEnabled: boolean = false;
    let smsMobileNumberEditable: boolean = false;
    let editMobileCaOtpEnabled: boolean = false;
    let editMobileSecQuestEnabled: boolean = false;
    let editMobileUigpOtpEnabled: boolean = false;
    let enableConsultanDelegation: boolean = false;
    let reqHistoryCsvLimit: number = 0;
    let reqRetryableType: number[] = [];

    for (let config of configurations) {
      switch (config.configuration) {
        case "REQUESTS_HISTORY_FETCH_LIMIT":
          reqHistoryCsvLimit = Number(config.value);
          break;
        case "RETRYABLE_REQUEST_TYPES":
          reqRetryableType = config.value
            .split(",")
            .map((val: string) => Number(val));
          break;
        case "SMS_ENABLED":
          smsEnabled = config.value === "true";
          break;
        case "SMS_MOBILE_NUMBER_EDITABLE_BY_USER":
          smsMobileNumberEditable = config.value === "true";
          break;
        case "MODIFY_PROFILE_CA_OTP_ENABLED":
          editMobileCaOtpEnabled = config.value === "true";
          break;
        case "MODIFY_PROFILE_SEC_QUESTIONS_ENABLED":
          editMobileSecQuestEnabled = config.value === "true";
          break;
        case "MODIFY_PROFILE_UIGP_OTP_ENABLED":
          editMobileUigpOtpEnabled = config.value === "true";
          break;
        case "DELEGATE_CONSULTANT_ENABLED":
          enableConsultanDelegation = config.value === "true";
          break;
      }
    }

    return compose(
      immutableSet([SMS_ENABLED], smsEnabled),
      immutableSet(
        [SMS_MOBILE_NUMBER_EDITABLE_BY_USER],
        smsMobileNumberEditable
      ),
      immutableSet([RETRYABLE_REQUEST_TYPES], reqRetryableType),
      immutableSet([REQUESTS_HISTORY_FETCH_LIMIT], reqHistoryCsvLimit),
      immutableSet([MODIFY_PROFILE_CA_OTP_ENABLED], editMobileCaOtpEnabled),
      immutableSet(
        [MODIFY_PROFILE_SEC_QUESTIONS_ENABLED],
        editMobileSecQuestEnabled
      ),
      immutableSet([MODIFY_PROFILE_UIGP_OTP_ENABLED], editMobileUigpOtpEnabled),
      immutableSet([DELEGATE_CONSULTANT_ENABLED], enableConsultanDelegation)
    )(state);
  },
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    action.payload.location.pathname === "/welcome"
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
